import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import WelcomeExperience from '../components/welcome/WelcomeExperience'

export default function WelcomePage() {
  useEffect(() => {
    document.title = 'Welcome | Synergy Multimedia Academy'
  }, [])

  return (
    <>
      <Helmet>
        <title>Welcome | Synergy Multimedia Academy</title>
        <meta
          name="description"
          content="Welcome to Synergy Multimedia Academy. Choose how you want to experience SMA — explore the academy, talk to an admissions advisor, or join our monthly masterclasses. Shaping Futures."
        />
        <link rel="canonical" href="https://synergymultimediaacademy.com/" />
        <meta property="og:title" content="Welcome | Synergy Multimedia Academy" />
        <meta
          property="og:description"
          content="Choose how you want to experience SMA — explore the academy, talk to an admissions advisor, or join the monthly masterclass series."
        />
        <meta property="og:url" content="https://synergymultimediaacademy.com/" />
      </Helmet>
      <WelcomeExperience />
    </>
  )
}
